import { useTranslation } from 'react-i18next'
import { ConfirmDialog } from '@/components/confirm-dialog'
import type { PendingInstallationDelete } from '@/features/installations/hooks/use-installation-delete-confirm'

type InstallationDeleteConfirmDialogProps = {
  pendingDelete: PendingInstallationDelete | null
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  isLoading?: boolean
}

export function InstallationDeleteConfirmDialog({
  pendingDelete,
  open,
  onOpenChange,
  onConfirm,
  isLoading = false,
}: InstallationDeleteConfirmDialogProps) {
  const { t } = useTranslation(['installations', 'common'])

  if (!pendingDelete) {
    return null
  }

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('installations:configuration.deleteConfirm.title')}
      desc={t('installations:configuration.deleteConfirm.description', {
        label: pendingDelete.label,
      })}
      cancelBtnText={t('common:actions.cancel')}
      confirmText={t('common:actions.delete')}
      destructive
      isLoading={isLoading}
      handleConfirm={onConfirm}
    />
  )
}
